module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title-acknowPage"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("S")]), _vm._v("everal people helped in the writing of this book. The library staff of Kendal, and the staff at Preston, Whitehaven, Barrow and Carlisle archives have been as helpful as it is possible to be. Many thanks to them.")]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_vm._v("Tracey from Essex and Tony March put up (with) the travelling researchers as did Wadvern Davies, whilst Lesley Harris fed us. Keith Thomas not only ferreted out some stuff we had missed at the archives in Whitehaven, but paid for lunch as well. George Stewart of Burneside also dug up the tail-end of a case for us when we had run out of time in Kendal. Without them, two of the stories in this book wouldn’t have made it into print. Ivor Davies read the manuscript looking for silly mistakes, so we all know who to blame if we find any.")]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_vm._v("Lastly, as ever, huge amounts of the research and typing were done by my wife, Pauline, who really should get a co-credit, but I like to keep all the royalties for myself. All photographs in this book are by the author.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Lancaster Castle. The castle served as gaol and assizes. Thomas Donahoo (Chapter 10), John Stainton (Chapter 9) and the suspects in the Trades Union murder (Chapter 15) all appeared here.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408467_i0002.jpg",
      "src": "images/e9781783408467_i0002.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4810db2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408467_ack01.vue
// module id = 69
// module chunks = 0